/* Shaky Records theme runtime: a tiny stand-in for the Design Component host.
   Renders the compiled template with Preact and drives the Component class. */
(function () {
  var h = preact.h;
  window.SR_A = function (id) {
    var n = (window.SR_AMAP || {})[id];
    return n ? (window.SR_ASSET_BASE || '') + n : '';
  };
  function L(S, p) {
    var parts = p.split('.'), v = S[parts[0]];
    for (var i = 1; i < parts.length && v != null; i++) v = v[parts[i]];
    return v;
  }
  function T(v) { return v == null || v === false || v === true ? (v === true ? 'true' : '') : String(v); }
  function A(u) {
    if (typeof u !== 'string') return u;
    return u.replace(/\/_blob\/([0-9a-f]{32})/g, function (m, id) { return window.SR_A(id) || m; });
  }
  window.SR_TPL_HELPERS = { h: h, L: L, T: T, A: A };

  window.DCLogic = function DCLogic(props) { this.props = props || {}; this.state = {}; };
  window.DCLogic.prototype.setState = function (o) {
    if (typeof o === 'function') o = o(this.state, this.props);
    if (o) Object.assign(this.state, o);
    if (this.__mounted) this.__schedule();
  };
  window.DCLogic.prototype.forceUpdate = function () { if (this.__mounted) this.__schedule(); };

  window.SR_MOUNT = function (Comp, tpl, root) {
    var c = new Comp({});
    var pending = false;
    c.__draw = function () {
      pending = false;
      preact.render(h(preact.Fragment, null, tpl(c.renderVals())), root);
    };
    c.__schedule = function () {
      if (pending) return;
      pending = true;
      Promise.resolve().then(function () { try { c.__draw(); } catch (e) { pending = false; console.error(e); } });
    };
    c.__mounted = true;
    c.__draw();
    if (c.componentDidMount) c.componentDidMount();
    window.SR_APP = c;
    return c;
  };
})();
